module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.order) ? _c('div', [_c('modal-edit-pending-information', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "confirm": function($event) {
        return _vm.orderUpdatePendingInformation()
      }
    },
    model: {
      value: (_vm.modalOrderEditPendingInformationFlag),
      callback: function($$v) {
        _vm.modalOrderEditPendingInformationFlag = $$v
      },
      expression: "modalOrderEditPendingInformationFlag"
    }
  }), _vm._v(" "), _c('modal-invoice', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "confirm": function($event) {
        return _vm.modalInvoice()
      }
    },
    model: {
      value: (_vm.modalInvoiceFlag),
      callback: function($$v) {
        _vm.modalInvoiceFlag = $$v
      },
      expression: "modalInvoiceFlag"
    }
  }), _vm._v(" "), _c('modal-unlink-order', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "confirm": function($event) {
        return _vm.unlinkOrder()
      }
    },
    model: {
      value: (_vm.modalUnlinkOrderFlag),
      callback: function($$v) {
        _vm.modalUnlinkOrderFlag = $$v
      },
      expression: "modalUnlinkOrderFlag"
    }
  }), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": _vm.title,
      "moduleIdentifier": _vm.identifier
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.order.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.order.status).label))])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12 l-col-6@sm l-col-3@lg"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('date.label'),
      "value": new Date(_vm.order.created.replace('.000Z', '')).toLocaleString('pt-br').split(' '),
      "icon": "icon-calendar",
      "color": "t-queue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12 l-col-6@sm l-col-3@lg"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('freightValue.label'),
      "value": _vm._f("currency")(_vm.order.payment.shipping),
      "icon": "icon-truck",
      "color": "t-denied"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12 l-col-6@sm l-col-3@lg"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('totalValue.label'),
      "value": _vm._f("currency")(_vm.order.payment.total),
      "icon": "icon-cash",
      "color": "t-success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12 l-col-6@sm l-col-3@lg"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('totalItems.label'),
      "value": _vm.totalItems.toString(),
      "icon": "icon-cart",
      "color": "t-waiting"
    }
  })], 1)]), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-8@md l-col-offset-2@md"
  }, [_c('stepper', {
    attrs: {
      "order": _vm.order.marketplace
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('client.label')
    }
  }, [(_vm.order.customer) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('name.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.name))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.isPersonal ? 'CPF' : 'CNPJ') + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.documentNumber))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('phone.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.phone))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('phoneMobile.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.mobile))) + "\n                ")])])]) : _c('div', {
    staticClass: "l-row u-textCenter full-height"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "vertical-center"
  }, [_vm._v("\n                  Dados não informados\n                ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('payment.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shippingPrice.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.shipping)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('subtotal.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.subtotal)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('installments.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm.order.payment.installments) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('saleFee.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.saleFee)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shippingFee.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.shippingFee)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('discount.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.discount)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('total.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.total)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('addition.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.order.payment.addition)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('method.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.getPaymentMethod(_vm.order.payment.method))) + "\n                ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('marketplace.label')
    }
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('identifier.label')) + ":")]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.order.marketplace.externalReference)) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('date.label')) + ":")]), _vm._v("\n             " + _vm._s(_vm._f("attribute")(_vm.adjustDate(_vm.order.marketplace.date))) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('channel.label')) + ":")]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.channel)) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shipmentService.name.label')) + ":")]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.$t(("shipmentService." + (_vm.order.marketplace.shipmentService) + ".label")))) + "\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('billingAddress.label')
    }
  }, [(_vm.order.customer && _vm.order.customer.address) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('name.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.name))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('street.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.street))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('number.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.number))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('complement.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.complement))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('district.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.district))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('city.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.city))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('state.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.state))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('zipCode.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.zipCode))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('referenceAddress.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.address.reference))) + "\n                ")])])]) : _c('div', {
    staticClass: "l-row u-textCenter"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_vm._v("\n                Dados não informados\n              ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('deliveryAddress.label')
    }
  }, [(_vm.order.shipping.address) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('name.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.name))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('street.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.street))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('number.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.number))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('complement.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.complement))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('district.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.district))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('city.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.city))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('state.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.state))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('zipCode.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.zipCode))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('referenceAddress.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.shipping.address.reference))) + "\n                ")])])]) : _c('div', {
    staticClass: "l-row u-textCenter"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_vm._v("\n                Dados não informados\n              ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingSyncExpediter
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.order.expediter.status
  }, [_vm._v(_vm._s(_vm.$t(_vm.order.expediter.status).label))]), _vm._v(" "), (_vm.order.expediter.status !== 'synchronized' && (_vm.order.expediter.identifier === 'moovin' || _vm.order.expediter.identifier === 'flexy' || _vm.order.expediter.identifier === 'oneeg') && _vm.order.customer !== null && _vm.order.shipping.address !== null) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "title": "Sincronizar"
    },
    on: {
      "click": _vm.syncExpediter
    }
  }, [_c('i', {
    staticClass: "icon-sync icon-loop2"
  })]) : _vm._e(), _vm._v(" "), (_vm.order.expediter.identifier == 'moovin' && _vm.order.customer !== null && _vm.order.shipping.address !== null && _vm.order.expediter.shipped == false && _vm.order.marketplace.invoiced == false && _vm.order.invoice.key == '') ? _c('button', {
    staticClass: "btn",
    attrs: {
      "title": "Desvincular com o Ecommerce"
    },
    on: {
      "click": function($event) {
        _vm.modalUnlinkOrderFlag = true
      }
    }
  }, [_c('i', {
    staticClass: "btn--danger icon-folder-remove"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('module.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.$t(((_vm.order.expediter.identifier) + ".label")))) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('code.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.order.expediter.code)) + "\n                ")]), _vm._v(" "), (_vm.order.marketplace.shipmentService) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shipped.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.$t(("shipmentService." + (_vm.order.expediter.shipped) + ".label")))) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.order.marketplace.shipmentService) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('delivered.label')) + ":")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.$t(("shipmentService." + (_vm.order.expediter.delivered) + ".label")))) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.order.expediter.message) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Mensagem:")]), _vm._v("\n                  " + _vm._s(_vm._f("attribute")(_vm.order.expediter.message)) + "\n                ")]) : _vm._e()])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-8@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": _vm.$t('products.label')
    }
  }, [_c('table', {
    staticClass: "table table--responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('code.label')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('expediter.code.label')))]), _vm._v(" "), (_vm.someItemHaveExternalCode) ? _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('externalCode.label')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('title.label')))]), _vm._v(" "), _c('th', {
    staticClass: "u-textRight",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('quantity.label')))]), _vm._v(" "), _c('th', {
    staticClass: "u-textRight",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.$t('order.item.price.label')))]), _vm._v(" "), _c('th', {
    staticClass: "u-textRight",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricePaid.label')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.shipping.items), function(item) {
    return _c('tr', {
      key: item.code
    }, [_c('td', {
      attrs: {
        "data-label": _vm.$t('expediter.code.label')
      }
    }, [_c('input', {
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": (_vm.isOrderSynchronized)
      },
      domProps: {
        "value": item.code
      },
      on: {
        "change": function($event) {
          return _vm.fillCode(item, $event)
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.$t('expediter.code.label')
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.expediterCode),
        expression: "item.expediterCode"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.isOrderSynchronized
      },
      domProps: {
        "value": (item.expediterCode)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "expediterCode", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.someItemHaveExternalCode) ? _c('td', {
      attrs: {
        "data-label": _vm.$t('externalCode.label')
      }
    }, [_vm._v(_vm._s(item.externalCode))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.$t('title.label')
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "u-textRight",
      attrs: {
        "data-label": _vm.$t('quantity.label')
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "u-textRight",
      attrs: {
        "data-label": _vm.$t('order.item.price.label')
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(item.price)))]), _vm._v(" "), _c('td', {
      staticClass: "u-textRight",
      attrs: {
        "data-label": _vm.$t('pricePaid.label')
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(item.pricePaid)))])])
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-12"
  }, [_c('panel', {
    attrs: {
      "title": "Faturamento"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "columns": 5,
      "label": "Chave NF",
      "error": _vm.getError('invoice.key')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.invoice.key),
      expression: "order.invoice.key"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.isBlockedToEditInvoiceData
    },
    domProps: {
      "value": (_vm.order.invoice.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.invoice, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 2,
      "label": "Número NF",
      "error": _vm.getError('invoice.number')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.invoice.number),
      expression: "order.invoice.number"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.isBlockedToEditInvoiceData
    },
    domProps: {
      "value": (_vm.order.invoice.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.invoice, "number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 2,
      "label": "Série NF",
      "error": _vm.getError('invoice.serial')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.invoice.serial),
      expression: "order.invoice.serial"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.isBlockedToEditInvoiceData
    },
    domProps: {
      "value": (_vm.order.invoice.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.invoice, "serial", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 3,
      "label": "Data de faturamento",
      "error": _vm.getError('invoice.date')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Data e Hora da postagem",
      "disabled": _vm.isBlockedToEditInvoiceData,
      "format": "dd/MM/yyyy HH:mm:ss",
      "timezone": "UTC"
    },
    model: {
      value: (_vm.order.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.order.invoice, "date", $$v)
      },
      expression: "order.invoice.date"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 5,
      "label": "Link NF",
      "error": _vm.getError('invoice.link')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.invoice.link),
      expression: "order.invoice.link"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.isBlockedToEditInvoiceData
    },
    domProps: {
      "value": (_vm.order.invoice.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.invoice, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.order.invoice.xml) ? _c('a', {
    staticClass: "hint hint--right",
    attrs: {
      "data-label": "Visualizar XML de nota fiscal"
    },
    on: {
      "click": function($event) {
        _vm.modalInvoiceFlag = true
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-file-text invoice-area"
  })]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12"
  }, [_c('panel', {
    attrs: {
      "title": "Transporte"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.hasPrintShipmentLabel && _vm.shipmentLabelUrl) ? _c('a', {
    staticClass: "hint hint--left",
    attrs: {
      "data-label": "Imprimir etiqueta",
      "href": _vm.shipmentLabelUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-printer"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-col-12 l-row"
  }, [_c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Número de rastreio"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.shipping.trackingCode),
      expression: "order.shipping.trackingCode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.isBlockedToEditTransportData
    },
    domProps: {
      "value": (_vm.order.shipping.trackingCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.shipping, "trackingCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Data da postagem",
      "error": _vm.getError('shipping.postDate')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Data e Hora da postagem",
      "disabled": _vm.isBlockedToEditTransportData,
      "format": "dd/MM/yyyy HH:mm:ss"
    },
    model: {
      value: (_vm.order.shipping.postDate),
      callback: function($$v) {
        _vm.$set(_vm.order.shipping, "postDate", $$v)
      },
      expression: "order.shipping.postDate"
    }
  })], 1), _vm._v(" "), (_vm.identifier === 'integracommerce' && this.defaultEstimatedDays && this.defaultEstimatedDays > 0) ? _c('form-group', {
    attrs: {
      "columns": 2,
      "label": "Dias úteis estimados"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.shipping.estimatedDays),
      expression: "order.shipping.estimatedDays"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.order.shipping.estimatedDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.shipping, "estimatedDays", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Data da entrega"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Data de Entrega",
      "disabled": _vm.isBlockedToEditDeliveryData,
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.order.shipping.deliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.order.shipping, "deliveryDate", $$v)
      },
      expression: "order.shipping.deliveryDate"
    }
  })], 1)], 1)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('simple-list-log', {
    attrs: {
      "options": _vm.logFilters
    }
  })], 1)]), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md u-textRight"
  }, [(_vm.order.shippingCustom && _vm.identifier === 'mercadoLivre') ? _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.modalOrderEditPendingInformationFlag = true
      }
    }
  }, [_c('i', {
    staticClass: "icon-pencil size"
  }), _vm._v(" \n        Editar informações pendentes\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success u-textRight",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": !_vm.isAllowedToSave && _vm.isOrderSynchronized,
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('i', {
    staticClass: "icon-floppy-disk size"
  }), _vm._v(" \n        Salvar\n      ")])])])])], 1) : _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e051d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/Detail/Base.vue
// module id = 3171
// module chunks = 0